export default __webpack_public_path__ + "static/media/objectives.c7c56f32.webp";